import React from 'react';
import { Client } from '../../types';

interface ClientsTableProps {
  clients?: Client[];
  onRowClick?: (clientId: string) => void;
  onEdit?: (clientId: string) => void;
  onDelete?: (clientId: string) => void;
}

const mockClients: Client[] = [
  {
    id: '1',
    name: 'Tech Corp Inc.',
    email: 'contact@techcorp.com',
    phone: '+1 (555) 123-4567',
    casesCount: 5,
    lastContact: '2024-01-12T14:20:00Z',
  },
  {
    id: '2',
    name: 'Acme Corporation',
    email: 'legal@acme.com',
    phone: '+1 (555) 234-5678',
    casesCount: 3,
    lastContact: '2024-01-11T09:15:00Z',
  },
  {
    id: '3',
    name: 'StartupXYZ',
    email: 'hr@startupxyz.com',
    phone: '+1 (555) 345-6789',
    casesCount: 2,
    lastContact: '2024-01-10T16:45:00Z',
  },
  {
    id: '4',
    name: 'Global Industries',
    email: 'info@globalind.com',
    phone: '+1 (555) 456-7890',
    casesCount: 8,
    lastContact: '2024-01-13T10:30:00Z',
  },
];

const ClientsTable: React.FC<ClientsTableProps> = ({
  clients = mockClients,
  onRowClick,
  onEdit,
  onDelete,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div className="dashboard-card rounded-2xl overflow-hidden">
      <div className="p-4 pb-0 mb-0 bg-transparent border-b-0 rounded-t-2xl">
        <h6 className="mb-0 font-semibold leading-normal text-lg text-slate-700 dark:text-slate-200">Clients</h6>
      </div>
      <div className="flex-auto p-4">
        <div className="overflow-x-auto">
          <table className="table-auto w-full align-middle mb-0">
            <thead>
              <tr>
                <th className="px-4 py-3 text-left align-middle text-[10px] font-bold uppercase tracking-wider text-slate-500 opacity-80 dark:opacity-90">Client</th>
                <th className="px-4 py-3 text-left align-middle text-[10px] font-bold uppercase tracking-wider text-slate-500 opacity-80 dark:opacity-90 ps-2">Phone</th>
                <th className="px-4 py-3 text-center align-middle text-[10px] font-bold uppercase tracking-wider text-slate-500 opacity-80 dark:opacity-90">Cases</th>
                <th className="px-4 py-3 text-center align-middle text-[10px] font-bold uppercase tracking-wider text-slate-500 opacity-80 dark:opacity-90">Last Contact</th>
                <th className="px-4 py-3 text-left align-middle text-[10px] font-bold uppercase tracking-wider text-slate-500 opacity-80 dark:opacity-90"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-600/50">
              {clients.map((client) => (
                <tr
                  key={client.id}
                  className="align-middle even:bg-slate-50 dark:even:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 cursor-pointer transition-colors"
                  onClick={() => onRowClick?.(client.id)}
                >
                  <td className="px-4 py-3 whitespace-nowrap align-middle">
                    <div className="flex items-center">
                      <div className="flex flex-col justify-center">
                        <h6 className="mb-0 text-xs font-semibold text-slate-700 dark:text-slate-200">{client.name}</h6>
                        <p className="text-xs text-slate-500 dark:text-slate-400 mb-0">{client.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap align-middle">
                    <p className="text-xs text-slate-600 dark:text-slate-300 mb-0">{client.phone || '—'}</p>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap align-middle text-center">
                    <span className="inline-flex items-center px-2 py-0.5 text-[10px] font-bold rounded-full bg-emerald-500/15 text-emerald-600 dark:bg-emerald-400/20 dark:text-emerald-400">
                      {client.casesCount}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap align-middle text-center">
                    <span className="text-xs font-bold text-slate-500 dark:text-slate-400">{formatDate(client.lastContact)}</span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap align-middle">
                    <div className="flex items-center gap-3" onClick={(e) => e.stopPropagation()}>
                      <button onClick={() => onEdit?.(client.id)} className="text-slate-500 font-bold text-xs hover:text-slate-700 dark:hover:text-slate-200" title="Edit user">Edit</button>
                      <button onClick={() => onDelete?.(client.id)} className="text-slate-500 font-bold text-xs hover:text-danger" title="Delete">Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ClientsTable;
